// extracted by mini-css-extract-plugin
export default {"list":"styles_list__QCdni"};